export default function getImageURL(src, w = null) {
  if (src.includes('img.paperform.co')) return src;
  if (src.includes('ts.paperform.app')) return src;
  if (src.startsWith('/')) {
    src = `https://paperform.co${src}`;
  }

  return `https://img.paperform.co/fetch/f_auto${w ? `,w_${w}` : ''}/${src}`;
}
